import { ZoneInteractor, ZoneRequest, ZoneStructRequest } from "../../Coordinator/Zone/ZoneInteractor";

export class ZoneViewModel {
	private interactor: ZoneInteractor;

	constructor() {
		this.interactor = new ZoneInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new ZoneRequest(
			obj["sgepzona"] ? parseInt(obj["sgepzona"]) : 0,
			obj["nome"] ? obj["nome"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new ZoneStructRequest(obj["sgepzona"] ? parseInt(obj["sgepzona"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}